import { useState, useEffect, useContext } from 'react';
import './_FormTable.css';
import { Modal, Button } from 'react-bootstrap';
import { Input, TextArea, InputColorPicker } from "../../../Layout/Forms/Form";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Slider from '@mui/material/Slider';
import EventFormRequest from './EventFormRequest';
import { toast } from 'react-toastify';
import { useParams } from "react-router-dom";
import { TwitterPicker } from 'react-color';
import Loading from '../../../../components/Loading';
import ModalConfirmation from '../../../Layout/Modals/ModalConfirmation';

const FormTable = ({ show, handleModalhide, id }) => {
    let params = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({
        // form: {
        //     id: 0,
        //     name: '',
        //     color: '#ea2c61',
        //     numberOfGuests: '',
        //     base_price: '',
        //     percentage_pre_payment: 100
        // },
        form: null,
        showColorPicker: false,
        errors: [],
    });
    const [modalConfirmationState, setModalConfirmationState] = useState({
        isVisible: false,
        param: 0,
        text: ''
    });
    const handleHideModalConfirmation = () => {
        setModalConfirmationState({
            isVisible: false,
            param: 0,
        });
    }


    const theme = createTheme({
        components: {
            MuiSlider: {
                styleOverrides: {
                    markLabel: {
                        color: '#fff',
                    },
                },
            },
        },
        palette: {
            primary: {
                main: "#fff",

            },
            secondary: {
                main: '#ea2c61',
            }
        },
        markLabel: {
            color: 'red',
        },


    });

    const marksPercentagePrePayment = [
        {
            value: 0,
            label: '0',
        },
        {
            value: 25,
            label: '25',
        },
        {
            value: 50,
            label: '50',
        },
        {
            value: 75,
            label: '75',
        },
        {
            value: 100,
            label: '100',
        },
    ];


    useEffect(async () => {
        if (show) {
            let info = await EventFormRequest.getTable({ id_events: params.id, id: id });
            if (info && info.status) {
                setState({
                    ...state,
                    form: info.data
                })
            }
        }
    }, [show])



    const handleSubmitForm = async () => {

        let errorArray = {};
        let error = false;
        if (!state.form.base_price || state.form.base_price === 0) {
            errorArray = {
                ...errorArray,
                ...{
                    base_price: ["O preço do bilhete tem de ser igual ou superior a 5€"]
                }
            };
            error = true;
        }
        if (state.form.base_price < 5) {
            errorArray = {
                ...errorArray,
                ...{
                    base_price: ["O preço do bilhete tem de ser igual ou superior a 5€"]
                }
            };
            error = true;
        }
        if (!state.form.name || state.form.name.length === 0) {
            errorArray = {
                ...errorArray,
                ...{
                    name: ["O nome da mesa é obrigatório"]
                }
            };
            error = true;
        }

        if (error) {
            toast.error("Verifique os erros apresentados no formulário", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
            setState({
                ...state,
                errors: errorArray
            });
            return;
        }

        setIsLoading(true);
        let info = await EventFormRequest.postTable({ ...state.form, id_events: params.id });
        if (info && info.status) {
            handleModalhide(false);
            toast.success("A mesa foi registado com sucesso", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
        } else {
            setState({
                ...state,
                errors: info.errors
            })
        }
        setIsLoading(false);
    }

    const handleChangeInputs = (e) => {
        if (!isLoading) {
            setState({
                ...state,
                form: {
                    ...state.form,
                    [e.target.name]: e.target.value
                }
            });
        }
    }


    const InputColorPicker = () => {
        if (state.showColorPicker) {
            return (
                <div className="form-tables-colorpicker-popover">
                    <div className="form-tables-colorpicker-cover" onClick={() => setState({
                        ...state,
                        showColorPicker: false
                    })} />
                    <TwitterPicker
                        onChangeComplete={handleChangeColorPicker}
                    />
                </div>
            )
        }
        return null;
    }

    const handleChangeColorPicker = (color, event) => {
        setState({
            ...state,
            form: {
                ...state.form,
                color: color.hex
            },
            showColorPicker: false
        })
    };

    const handleConfirmDelete = () => {
        setModalConfirmationState({
            isVisible: true,
            param: {},
            text: 'Deseja eliminar a mesa?'
        });
    }
    const handlerDeletetable = async () => {
        handleHideModalConfirmation();
        const response = await EventFormRequest.deleteTable({ id_events: params.id, id: id });
        if (response.status) {
            toast.success("Mesa eliminada com sucesso.", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
            handleModalhide();
        } else {
            if (response.msg && response.msg.length > 0) {
                toast.error(response.msg, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
            } else {
                toast.error("Ocorreu um erro ao eliminar a mesa", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
            }
        }
    };

    return (

        <>
            <Modal show={show} onHide={handleModalhide} contentClassName="glass-modal">
                <Modal.Header >
                    <Modal.Title>Gerir Mesa</Modal.Title>
                </Modal.Header>

                <Modal.Body className="bg-dark text-white p-4">
                    {!state.form ? (
                        <div className="d-flex justify-content-center py-5">
                            <Loading />
                        </div>
                    ) : (
                        <div className="animate-fade-in">
                            <div className="row g-4">
                                {/* Row 1: Name and Color */}
                                <div className="col-md-8">
                                    <h5 className="text-white-50 mb-3 text-uppercase fs-6 ls-1">Informação Básica</h5>
                                    <Input
                                        label="Nome da Mesa"
                                        name="name"
                                        value={state.form.name}
                                        onChange={(e) => handleChangeInputs(e)}
                                        type="text"
                                        placeholder="Ex: Mesa VIP Lounge"
                                        errors={state.errors}
                                        className="form-control form-input form-control-lg bg-dark-2 border-dark-3 text-white"
                                    />
                                </div>
                                <div className="col-md-4">
                                    <h5 className="text-white-50 mt-sm-4 mb-3 text-uppercase fs-6 ls-1 opacity-0">.</h5>
                                    <div className="position-relative h-100">
                                        <button
                                            className="btn w-100 d-flex align-items-center justify-content-between p-3 border-0 transition-hover"
                                            style={{
                                                backgroundColor: state.form.color || '#333',
                                                color: '#fff',
                                                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                                height: '52px', // Match input height
                                                marginTop: '0px'
                                            }}
                                            onClick={() => setState({ ...state, showColorPicker: true })}
                                        >
                                            <span className="fw-bold text-shadow">
                                                {state.form.color ? state.form.color : 'Cor'}
                                            </span>
                                            <i className="fas fa-palette ms-2"></i>
                                        </button>
                                        <div className="position-relative">
                                            <InputColorPicker />
                                        </div>
                                    </div>
                                </div>

                                {/* Row 2: Description */}
                                <div className="col-12">
                                    <TextArea
                                        label="Descrição"
                                        name="description"
                                        value={state.form.description}
                                        onChange={(e) => handleChangeInputs(e)}
                                        type="text"
                                        rows="4"
                                        errors={state.errors}
                                        className="form-control form-input bg-dark-2 border-dark-3 text-white"
                                        placeholder="Descreva as características desta mesa..."
                                    />
                                </div>
                            </div>

                            <hr className="border-secondary opacity-25 my-4" />

                            <h5 className="text-white-50 mb-3 text-uppercase fs-6 ls-1">Detalhes & Preço</h5>
                            <div className="row g-4">
                                {/* Row 3: Capacity and Price */}
                                <div className="col-md-6">
                                    <Input
                                        label="Capacidade Max."
                                        name="limit_numberOfGuests"
                                        value={state.form.limit_numberOfGuests}
                                        onChange={(e) => handleChangeInputs(e)}
                                        className='form-control form-input bg-dark-2 border-dark-3 text-white text-end'
                                        type="number"
                                        errors={state.errors}
                                        placeholder="0"
                                    />
                                </div>

                                <div className="col-md-6">
                                    <Input
                                        label="Preço Base (€)"
                                        name="base_price"
                                        value={state.form.base_price}
                                        onChange={(e) => handleChangeInputs(e)}
                                        className='form-control form-input bg-dark-2 border-dark-3 text-white text-end'
                                        type="number"
                                        errors={state.errors}
                                    />
                                    <small className="text-muted d-block mt-1 fst-italic">
                                        *Valor mínimo de 5€
                                    </small>
                                </div>

                                {/* Row 4: Pre-payment */}
                                <div className="col-12">
                                    <div className="p-4 bg-dark-2 rounded-3 border border-secondary border-opacity-10">
                                        <label className="form-label d-flex justify-content-between mb-2">
                                            <span className="text-white fw-bold">Pré-Pagamento Obrigatório</span>
                                            <span className="text-success fw-bold fs-5">{state.form.percentage_pre_payment}%</span>
                                        </label>
                                        <div className="px-3 pt-2">
                                            <ThemeProvider theme={theme}>
                                                <Slider
                                                    value={state.form.percentage_pre_payment}
                                                    name='percentage_pre_payment'
                                                    onChange={handleChangeInputs}
                                                    min={25}
                                                    max={100}
                                                    step={25}
                                                    valueLabelDisplay="auto"
                                                    marks={marksPercentagePrePayment}
                                                    sx={{
                                                        color: '#ea2c61',
                                                        height: 8,
                                                        '& .MuiSlider-markLabel': { color: 'rgba(255,255,255,0.5)', fontSize: '0.9rem' },
                                                        '& .MuiSlider-markLabelActive': { color: '#fff', fontWeight: 'bold' },
                                                        '& .MuiSlider-thumb': { width: 24, height: 24 }
                                                    }}
                                                />
                                            </ThemeProvider>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer className="bg-dark border-top border-secondary border-opacity-10 p-3">
                    <div className="d-flex justify-content-between w-100 gap-3">
                        <Button
                            variant="outline-danger"
                            className="px-4 py-2 opacity-75 hover-opacity-100"
                            onClick={handleConfirmDelete}
                        >
                            <i className="far fa-trash-alt me-2"></i>
                            Eliminar
                        </Button>
                        <div className="d-flex gap-2">
                            <Button
                                variant="link"
                                className="text-white text-decoration-none px-4 py-2"
                                onClick={handleModalhide}
                            >
                                Cancelar
                            </Button>
                            <Button
                                className="btn-action-primary px-5 py-2 fw-bold shadow-lg"
                                onClick={() => handleSubmitForm()}
                            >
                                Guardar Alterações
                            </Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
            <ModalConfirmation
                show={modalConfirmationState.isVisible}
                param={modalConfirmationState.param}
                handleModalhide={handleHideModalConfirmation}
                handleModalConfirm={(param) => handlerDeletetable(param)}
                text={modalConfirmationState.text}
            />
        </>
    );
}

export default FormTable;